import script from "./code_confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./code_confirmation.vue?vue&type=script&setup=true&lang=js"

import "./code_confirmation.vue?vue&type=style&index=0&id=e60c42c0&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e60c42c0"]])

export default __exports__